import AttendancePage from '../../components/attendancePage';

const EmployeeAttendance = () => (
  <AttendancePage userType="employee" title="Employee Attendance" />
);

export default EmployeeAttendance;
